import { useTranslation } from "react-i18next";
import Accordion from "components/General/Accordion";

export default function ServicesTopFAQ() {
  const { t } = useTranslation();

  const faqs = [
    {
      title: t("CustomerFaq-title-4"),
      desc: t("CustomerFaq-desc-4"),
    },
    {
      title: t("CustomerFaq-title-5"),
      desc: t("CustomerFaq-desc-5"),
    },
    {
      title: t("CustomerFaq-title-11"),
      desc: t("CustomerFaq-desc-14"),
    },
    {
      title: t("CustomerFaq-title-18"),
      desc: t("CustomerFaq-desc-38"),
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-4">
      {faqs.map((faq, idx) => (
        <Accordion item={faq} key={`FAQ - ${idx}`} />
      ))}
    </div>
  );
}
